// removed by extract-text-webpack-plugin
module.exports = {"featureArticleTag":"_2dF6mFk1y2v8kznOdM45-V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureArticleTag/FeatureArticleTag.module.scss
// module id = 756
// module chunks = 0